import React, { useState, useEffect } from "react";
import "./HasNewButton.scss";

import moment from "moment";
import { TeasersService } from "../../../utils/api";
import BigLabel from "../../../ui/BigLabel/BigLabel";
import useGlobals from "../../../hooks/useGlobals";

function isSearchById(search) {
  const term = search.search_term || "";
  return !!term.match(/^\d+$/);
}

const HasNewButton = ({ appendNewTeasers, search }) => {
  const [teasers, setTeasers] = useState([]);
  const [since, setSince] = useState(moment.utc());
  const globals = useGlobals();

  const setNew = () => {
    if (teasers.length >= globals.paginate_by) {
      window.location.reload();
    }

    appendNewTeasers(teasers);
    setTeasers([]);

    setSince(moment.utc());
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const filters = { ...search, date_from: since.format(), page: 1 };

    const interval = setInterval(() => {
      if (!isSearchById(search) && (search.cid || search.user)) {
        TeasersService(filters)
          .then(({ teasers }) => {
            setTeasers(teasers);
          })
          .catch(e => {
            console.log(e);
          });
      }
    }, 15 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [search, since]);

  if (teasers.length == 0) {
    return null;
  }

  return (
    <div className="teaser-list-refresh">
      <div className="teaser-list-refresh__content">
        <BigLabel onClick={setNew}>
          Появились новые анонсы ({teasers.length}). Обновить?
        </BigLabel>
      </div>
    </div>
  );
};

export default HasNewButton;
